import { Phone } from "lucide-react";
import { CONTACT, waLink } from "@/constants/content";
import { scrollToSection } from "@/hooks/useLenis";

const WhatsAppIcon = (props) => (
  <svg viewBox="0 0 32 32" width="22" height="22" fill="currentColor" {...props}>
    <path d="M16 .5C7.4.5.5 7.4.5 16c0 3 .8 5.7 2.3 8.1L.6 31.5l7.6-2c2.3 1.3 5 2 7.8 2 8.6 0 15.5-6.9 15.5-15.5S24.6.5 16 .5Zm0 28.2c-2.5 0-4.9-.7-7-1.9l-.5-.3-4.5 1.2 1.2-4.4-.3-.5A12.7 12.7 0 0 1 3.3 16c0-7 5.7-12.7 12.7-12.7S28.7 9 28.7 16 23 28.7 16 28.7Zm7-9.5c-.4-.2-2.2-1.1-2.6-1.2-.3-.1-.6-.2-.8.2-.2.4-.9 1.2-1.2 1.4-.2.2-.4.3-.8.1-.4-.2-1.6-.6-3-1.9-1.1-1-1.9-2.2-2.1-2.6-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.1-.8-.1-.3-1-2.4-1.3-3-.2-.4-.4-.4-.8-.4h-.6c-.3 0-.7.1-1 .5-.4.4-1.4 1.4-1.4 3.3 0 2 1.4 3.9 1.6 4.2.2.3 2.7 4.1 6.6 5.6 3.9 1.5 3.9 1 4.6.9.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.8-.1-.2-.3-.3-.7-.5Z" />
  </svg>
);

export const FloatingCTAs = () => {
  const enquire = () => scrollToSection("#enquire");
  return (
    <>
      <div className="cp-float-stack" data-testid="floating-cta-stack">
        <a
          href={waLink("Hi, I'm interested in Central Plaza SCO units at Sector 10A, Kharkhoda. Please share more details.")}
          target="_blank"
          rel="noreferrer"
          className="cp-float-btn cp-float-wa"
          data-testid="floating-whatsapp-btn"
          aria-label="Chat on WhatsApp"
        >
          <WhatsAppIcon />
        </a>
        <a
          href={`tel:${CONTACT.tel}`}
          className="cp-float-btn cp-float-call"
          data-testid="floating-call-btn"
          aria-label="Call Now"
        >
          <Phone size={20} />
        </a>
      </div>

      <div className="cp-sticky-mobile" data-testid="sticky-mobile-cta">
        <a href={`tel:${CONTACT.tel}`} className="cp-sticky-btn cp-sticky-call" data-testid="sticky-call-btn">
          <Phone size={16} /> Call Now
        </a>
        <button className="cp-sticky-btn cp-sticky-enquire" onClick={enquire} data-testid="sticky-enquire-btn">
          Enquire Now
        </button>
      </div>
    </>
  );
};
